var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-icon',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip",value:(_vm.$options.i18n.tooltip),expression:"$options.i18n.tooltip"}],attrs:{"name":"eye-slash"}})
}
var staticRenderFns = []

export { render, staticRenderFns }